// White-label component overrides — WHITE-LABEL HOSTS ONLY.
//
// ⚠️ Nika, 2026-08-19: "do not change anything for symbols — this is for
// bellforge workspace gate only." Nothing in this folder is exported from
// `components/index.js`. `context.js` spreads this barrel into
// `context.components` ONLY when `isCustomDomainHost()` is true, so on every
// platform host (my.symbols.app, canvas, preview, marketplace, *.localhost)
// the component graph never sees these keys at all.
//
// Both overrides use the same-name library-override pattern already proven
// in this package by `components/AppSidebar.js`, and both read their content
// from the org's `branding` record (functions/whitelabelBrand.js) — never a
// hardcoded customer value.
export * from './MainLoader.js'
export * from './RequestAccess.js'
